export default {
    props: {
        singleSelect: {
            default() {
                return false;
            }
        },
        multiple: {
            default() {
                return false;
            }
        },
        noAction: {
            default() {
                return false;
            }
        }
    },
    data: function () {
        return {
            entityService: null,
            search: "",
            searchFields: [],
            indexSelected: null,
            pagination: {
                page: 1,
                length: 1,
                total: 0,
                limit: this.$rowsLimit
            },
            form: { alert: { alerts: [], type: "error" } },
            loadingDialog: false,
            loadingTable: false,
            alert: { alerts: [], type: "error" },
            itemSelected: null,
            itemSelectedRef: null,
            items: [

            ],
        }
    },
    computed: {
        lengthPaginationComp() {
            let total = this.pagination.total;
            let round = Math.ceil(total / this.$rowsLimit);
            return total < 1 ? 1 : round;
        },
    },
    watch: {
        async "pagination.page"() {
            window.scrollTo(0, 0);
            await this.getItems();
        }
    },
    methods: {
        async searchTable(value) {
            this.search = value;
            this.pagination.page = 1;
            await this.getItems();
        },
        clickTable(row) {
            this.$emit("click", row);
        },


        // Open job/item
        async editItem(item, noDialog, noModelDefault) {
            let index = this.items.indexOf(item);
            this.indexSelected = index >= 0 ? index : null;

            if (item) {

                this.itemSelectedRef = item;

                let obj = {};
                Object.assign(obj, item);
                this.itemSelected = obj;

                if (!noDialog)
                    this.$refs.dialogEdit.open();
                return;
            }

            if (!noModelDefault)
                this.itemSelected = await this.getModelDefault();
            else this.itemSelected = null

            if (!noDialog)
                this.$refs.dialogEdit.open();
        },

        async saveItem(item, formIsValid, noDialog, successMsg) {

                console.log("pgList", item);
            if (formIsValid != null && formIsValid == false) {
                this.errorNotification([this.$t('errors.requiredFieldsEmpty')], true)
                return;
            }
            this.loadingDialog = true;
            var res = await this.entityService.insertOrUpdate(item);
            this.loadingDialog = false;

            if (res.success) {
                if (!noDialog) this.$refs.dialogEdit.open();

                if (successMsg) this.successNotification([successMsg]);

                this.itemSelected = null;
                this.itemSelectedRef = null;
            }
            else this.errorNotification(res.data, true);


            if (res.success) {
                this.form.alert.alerts = []
                this.alert.alerts = []
                await this.getItems();
            }


        },


        async deleteItem(item, dialog) {
            if (!(await this.$confirm())) {
                if (dialog == true) this.$refs.dialogEdit.open();
                return;
            }
            this.loadingDialog = true;

            var res = await this.entityService.delete(item.id);
            if (res.success) {
                this.itemSelected = null;
                this.itemSelectedRef = null;
                await this.getItems();
            }
            else this.errorNotification(res.data, true);

            this.loadingDialog = false;
            if (dialog == true) this.$refs.dialogEdit.open();
            this.itemSelected = null;
        },

        async getAutoInc(collection, type) {
            let res = await this.$http.post(`autoinc?collection=${collection ? collection : ""}&type=${type ? type : ""}`);
            if (res.success) return res.data;
            this.errorNotification(res.data);
        },

        async getItems() {

            //let idParam = "";
            //let idParamName = this.idParamName;
            //let getAllByIdParam = this.getAllByIdParam;
            //idParam = this.$route.params[idParamName];

            //let url = getAllByIdParam ? `${this.apiController}?${idParamName}=${idParam}` : this.apiController;
            this.loadingTable = true;
            let res = this.search && this.search.length > 0 ? await this.entityService.search(this.searchFields, this.search, this.pagination.page, this.$rowsLimit) :
                await this.entityService.getAll(this.pagination.page, this.$rowsLimit)

            //this.$http.get(
            //    url,
            //    noPagination ? null : this.pagination.page,
            //    noPagination ? null : this.$rowsLimit
            //);
            if (res.success) {
                this.items = res.data.data;
                this.pagination.total = res.data.total

            } else {
                this.errorNotification(res.data);
            }

            this.loadingTable = false;
        },
        errorNotification(list, form) {
            if (form) {
                this.form.alert.alerts = list;
                this.form.alert.type = "error";
                return;
            }
            this.alert.alerts = list;
            this.alert.type = "error";
        },
        clearNotifications() {
            if (this.alert && this.alerts) {
                this.alert.alerts = []
                this.alert.type = 'error'
            }

            if (this.form && this.form.alert && this.form.alert.alerts) {
                this.form.alerts = []
                this.form.type = 'error'
            }

        },
        successNotification(list, form) {
            if (form) {
                this.form.alert.alerts = list;
                this.form.alert.type = "success";
                return;
            }
            this.alert.alerts = list;
            this.alert.type = "success";
        }
    }
}